import request from '@/utils/http.js';
import qs from 'qs';

// 获取热门策略数据
export function getHotTactics(options) {
  return request({
    url: `${window.config.api_v1}/home/getHotCl`,
    method: 'GET',
    params: options
  });
}
// 获取行情
export function getFactorHq(options) {
  return request({
    url: `${window.config.api_v1}/quotation/getFactorHq`,
    method: 'GET',
    params: options
  });
}

// 关注因子/关注策略/关注模拟盘
export function addMyFavor(options) {
  return request({
    url: `${window.config.api_v1}/home/addMyFavor`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

// 取消关注 (因子/策略/模拟盘)
export function delMyFavor(options) {
  return request({
    url: `${window.config.api_v1}/home/delMyFavor`,
    method: 'GET',
    params: options
  });
}

// 热门模拟交易
export function getHotMokpanel(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getHotMokpanel`,
    method: 'GET',
    params: options
  });
}

//查询多因子策略 详情
export function getDyzClById(options) {
  return request({
    url: `${window.config.api_v1}/backtest/getDyzClById`,
    method: 'GET',
    params: options
  });
}

// 今日信号池
export function getObjSort(options) {
  return request({
    url: `${window.config.api_v1}/element/getObjSort`,
    method: 'GET',
    params: options
  });
}

// 给默认分组添加股票
export function insertStockByGroup(options) {
  return request({
    url: `${window.config.api_v1}/element/insertStockByGroup`,
    method: 'GET',
    params: options
  });
}

// 根据条件获取多因子策略参考收益分析
export function getIncomeanalysis(options) {
  return request({
    url: `${window.config.api_v1}/backtest/getIncomeanalysis`,
    method: 'GET',
    params: options
  });
}

// 查询多因子历史明细
export function getDyzHistory(options) {
  return request({
    url: `${window.config.api_v1}/backtest/getDyzHistory`,
    method: 'GET',
    params: options
  });
}

// 模拟交易详情 -- 基本信息
export function getMokpanelDetails(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getMokpanelDetails`,
    method: 'GET',
    params: options
  });
}

// 模拟交易详情 -- 收益详情 以及 分析
export function getMokpanelDetailsQuery(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getMokpanelDetailsQuery`,
    method: 'GET',
    params: options
  });
}

// 模拟交易详情 -- 计划交易
export function getMokpanelTradingplan(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getMokpanelTradingplan`,
    method: 'GET',
    params: options
  });
}

// 模拟交易详情 -- 持仓详情 (实时)
export function getMokpanelHold(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getMokpanelHold`,
    method: 'GET',
    params: options
  });
}

// 模拟交易详情 -- 今日调仓 or 历史调仓
export function getMokpanelDeal(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getMokpanelDeal`,
    method: 'GET',
    params: options
  });
}

// 开启微信推送
export function openWechat(options) {
  return request({
    url: `${window.config.api_v1}/transaction/openWechat`,
    method: 'GET',
    params: options
  });
}

// 关闭模拟交易
export function mockpanelClose(options) {
  return request({
    url: `${window.config.api_v1}/transaction/mockpanelClose`,
    method: 'GET',
    params: options
  });
}

// 获取我的自选股
export function getMyZxStockInfo(options) {
  return request({
    url: `${window.config.api_v1}/element/getMyZxStockInfo`,
    method: 'GET',
    params: options
  });
}

// 上报浏览数据
export function reportBrowse(options) {
  return request({
    url: `${window.config.api_v1}/element/reportBrowse`,
    method: 'GET',
    params: options
  });
}

// 获取用户名加服务器时间
export function getUserToDay(options) {
  return request({
    url: `${window.config.api_v1}/element/getUserToDay`,
    method: 'GET',
    params: options
  });
}

//回测校验
export function factorArrCheckout(params = {}) {
  return request({
    url: `${window.config.api_v1}/Checkout/factorArrCheckout`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 设置移动端弹窗数据
export function setClientRedis(options) {
  return request({
    url: `${window.config.api_v1}/open/setClientRedis`,
    method: 'GET',
    params: options
  });
}

// 查询移动端弹窗数据
export function getClientRedis(options) {
  return request({
    url: `${window.config.api_v1}/open/getClientRedis`,
    method: 'GET',
    params: options
  });
}

// 根据条件获取因子的最优参数
export function getInalysis(options) {
  return request({
    url: `${window.config.api_v1}/element/getIncomeanalysis`,
    method: 'GET',
    params: options
  });
}

// 获取分享ID
export function setShareById(options) {
  return request({
    url: `${window.config.api_v1}/element/setShareById`,
    method: 'GET',
    params: options
  });
}

//获取热门模拟交易盈亏概况
export function getHotMokpanelSurvey(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getHotMokpanelSurvey`,
    method: 'GET',
    params: options
  });
}

//获取热门模拟交易榜单
export function getHotMokpanelList(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getHotMokpanelList`,
    method: 'GET',
    params: options
  });
}

//获取模拟交易领涨股
export function getHotMokpanelLeading(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getHotMokpanelLeading`,
    method: 'GET',
    params: options
  });
}

// 获取今日热门策略TOP
export function getClHotStock(options) {
  return request({
    url: `${window.config.api_v1}/home/getClHotStock`,
    method: 'GET',
    params: options
  });
}

// 搜索A股
export function getStockQuery(options) {
  return request({
    url: `${window.config.api_v5}/stock/query`,
    method: 'GET',
    params: options
  });
}

// 获取个股动态-最新关联组合
export function getAssemblyToStock(options) {
  return request({
    url: `${window.config.api_v1}/open/getAssemblyToStock`,
    method: 'GET',
    params: options
  });
}

//获取热门模拟交易调仓动态
export function getHotDynamicsHome(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getHotDynamicsHome`,
    method: 'GET',
    params: options
  });
}

//更多优质策略
export function getHotClLeaderboard(options) {
  return request({
    url: `${window.config.api_v1}/home/getHotClLeaderboard`,
    method: 'GET',
    params: options
  });
}

//更多优质策略--more
export function getHotdynamicsMore(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getHotdynamicsMore`,
    method: 'GET',
    params: options
  });
}

//策略广场数据(商城热门模拟交易)
export function getHotMarket(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getHotMarket`,
    method: 'GET',
    params: options
  });
}


// 券商页-查询用户权限以及实盘信息
export function getUserCheck(options) {
  return request({
    url: `${window.config.api_v1}/open/getUserCheck`,
    method: 'GET',
    params: options
  });
}

// 给用户开启临时权限(217)
export function setUserPower(options) {
  return request({
    url: `${window.config.api_v1}/open/setUserPower`,
    method: 'GET',
    params: options
  });
}

// 查询可以导出的模拟交易
export function getMyRealityMn(options) {
  return request({
    url: `${window.config.api_v1}/reality/getMyRealityMn`,
    method: 'GET',
    params: options
  });
}

// 绑定券商信息
export function insertQsInfo(options) {
  return request({
    url: `${window.config.api_v1}/reality/insertQsInfo`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

// 签约安全入库
export function actionSign(options) {
  return request({
    url: `${window.config.api_v1}/event/actionSign`,
    method: 'GET',
    params: options
  });
}

// 查询签约状态
export function getSignStatus(options) {
  return request({
    url: `${window.config.api_v1}/open/getSignStatus`,
    method: 'GET',
    params: options
  });
}

// 查询券商开户状态 getOpenStatus
export function getOpenStatus(options) {
  return request({
    url: `${window.config.api_v1}/open/getOpenStatus`,
    method: 'GET',
    params: options
  });
}


// 获取JSON文件数据

export function getJsonData(options) {
  return request({
    url: '/config.json',
    method: 'GET',
    params: options
  });
}


// 获取键盘宝
export function searchJpb(options) {
  return request({
    url: `${window.JIANPANBAO}`,
    method: 'GET',
    params: options
  });
}